import { useContext, useState, useEffect } from "react";
import { DataContext } from "../DataContext";
import { useAuth0 } from "@auth0/auth0-react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { HeaderLogo, ShoppingBagIcon } from "../svgs";

import { MenuButton, NavigationBar, ButtonLink, NavigationItems, Announcements, NavLinks, CartIcon, LogoAndNav, Wrapper } from "../styles";

function NavbarComponent() {
  const { isLoading, isAuthenticated, loginWithRedirect } = useAuth0();
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);
  const { productsInCart, addVisitedPage } = useContext(DataContext);

  const location = useLocation();

  useEffect(() => {
    // Close the modal when the route changes
    setShowModal(false);
    addVisitedPage(location.pathname);
  }, [location]);

  const AccountButton = () => {
    if (isLoading) return <></>;
    if (isAuthenticated) {
      return (
        <Link className="account-link" to={"/account"} aria-label="My Account">
          Account
        </Link>
      );
    }
    return (
      <Link className="account-link" onClick={loginWithRedirect} role="button">
        Sign In
      </Link>
    );
  };

  const handleMobileNav = () => {
    handleShowModal();
  };

  const productsCount = productsInCart.reduce((sum, product) => sum + Number(product.quantity), 0);

  return (
    <>
      <Announcements>FREE SHIPPING on orders $100+</Announcements>
      <NavigationBar>
        <NavigationItems>
          <LogoAndNav>
            <Link className="logo" to="/" aria-label="Back to Grey Gull Homepage">
              <HeaderLogo />
            </Link>
            <div className="nav-menu left">
              <NavLinks>
                <Link to="/designs">Designs</Link>
                <Link to="/size-guide">Size Guide</Link>
                <Link to="/gallery">Gallery</Link>
              </NavLinks>
            </div>
          </LogoAndNav>

          <div className="get-started">
            <span>Ready To Get Started?</span>
            <ButtonLink to="/designs" className="small">
              Choose a Design
            </ButtonLink>
          </div>

          <div className="nav-menu right">
            <NavLinks>
              <AccountButton />
            </NavLinks>
            <CartIcon className="bag-link" to="/bag" aria-label="Shopping Bag">
              <ShoppingBagIcon aria-hidden="true" />
              {productsCount > 0 && <span>{productsCount}</span>}
            </CartIcon>
          </div>
          <MenuButton onClick={handleMobileNav}>
            <i className="fa-solid fa-bars"></i>
          </MenuButton>
        </NavigationItems>
      </NavigationBar>
      <Modal fullscreen={true} animation={false} show={showModal} onHide={handleCloseModal}>
        <Announcements>FREE SHIPPING on orders $100+</Announcements>
        <Wrapper className="modal-styles navigation">
          <Modal.Header closeButton>
            <Modal.Title>
              <LogoAndNav>
                <Link className="logo" to="/" aria-label="Back to Grey Gull Homepage">
                  <HeaderLogo />
                </Link>
              </LogoAndNav>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mobile-navigation">
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/designs">Designs</Link>
                </li>
                <li>
                  <Link to="/size-guide">Size Guide</Link>
                </li>
                <li>
                  <Link to="/gallery">Gallery</Link>
                </li>
                <li>
                  <Link to="/account">Account</Link>
                </li>
                <li>
                  <Link to="/bag">Shopping Bag</Link>
                </li>
              </ul>
            </div>
          </Modal.Body>
        </Wrapper>
      </Modal>
    </>
  );
}

export default NavbarComponent;
